    const searchSynonyms = {  
  "wedges": ["wedges", "wedge", "kolha wedge", "kohla wedges"],
  "mules": ["mules", "mule"],
  "juttis": ["jutti", "juttis", "juti"],
  "bags": ["bags", "bag", "handbag", "handbags", "potli", "tote bag"],
  "bag charms": ["charms", "charm", "bag charm", "bag charms", "keychain"],
  "sliders": ["sliders", "slides", "slide", "slidders", "bomba sliders"],
  "heels": ["heels", "heel", "heela", "hel"],
  "loafers": ["loafers", "loafer", "loffers", "loafters", "lofers"],
  "flats": ["flats", "flat", "kolha"]
};
//"cozy mules": ["cozy mule", "cozy mules", "cosy mule", "free cozy mule"],

function normalizeQuery(query) {
  query = query.toLowerCase().trim();

  // 1. Exact or contains match (your current logic)
  for (const main in searchSynonyms) {
    if (searchSynonyms[main].some(term => query.includes(term))) {
      return main;
    }
  }

  // 2. Prefix / partial match (NEW)
  for (const main in searchSynonyms) {
    if (
      main.startsWith(query) || // "co" → "cozy mules"
      searchSynonyms[main].some(term => term.startsWith(query)) // "coz" → "cozy mule"
    ) {
      return main;
    }
  }

  // 3. Loose fuzzy match (handles "csy", "lfr", etc.)
  for (const main in searchSynonyms) {
    const simplified = main.replace(/\s/g, ''); // "cozymules"

    let matchCount = 0;
    for (let char of query) {
      if (simplified.includes(char)) matchCount++;
    }

    if (matchCount >= Math.ceil(query.length * 0.6)) {
      return main;
    }
  }

  return query;
}


if (!customElements.get('search-suggestions')) {
  const SearchSuggestions = class extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = -1;
      this.searchInput = this.closest('form').querySelector('input[name="q"]');
      this.searchInput.addEventListener('keyup', this.handleInputChange.bind(this));
      this.searchInput.addEventListener('change', this.handleInputChange.bind(this));
    }

    handleInputChange() {
      const valueToSearch = this.searchInput.value;

     // if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
     if (valueToSearch.length >= 2 && valueToSearch !== this.oldSearchValue) {
        clearTimeout(this.searchTimeoutID);

        this.searchTimeoutID = setTimeout(() => {
          this.fetchSuggestions(valueToSearch);
        }, 500);
      } else if (!valueToSearch.length) {
        clearTimeout(this.searchTimeoutID);

        if (this.searchSuggestionsAbortController) {
          this.searchSuggestionsAbortController.abort('Existing request not needed');
          this.searchSuggestionsAbortController = null;
        }

        this.innerHTML = '';
      }

      this.oldSearchValue = valueToSearch;
    }



    // fetchSuggestions(terms) {
    //   if (this.searchSuggestionsAbortController) {
    //     this.searchSuggestionsAbortController.abort('Existing request not needed');
    //   }
    //   this.searchSuggestionsAbortController = new AbortController();

    //   fetch(`${theme.routes.predictiveSearch}?q=${encodeURIComponent(terms)}&section_id=search-suggestions`, {
    //     signal: this.searchSuggestionsAbortController.signal
    //   })
    //     .then((response) => {
    //       if (!response.ok) {
    //         throw new Error(response.status);
    //       }
    //       return response.text();
    //     })
    //     .then((text) => {
    //       const results = new DOMParser()
    //         .parseFromString(text, 'text/html')
    //         .querySelector('.search-suggestions-wrapper');

    //       this.innerHTML = '';
    //       this.insertAdjacentElement('beforeend', results.firstElementChild);
    //     })
    //     .catch((error) => {
    //       console.warn(error);
    //       if (error.code === 20) {
    //         return; // aborted
    //       }
    //       throw error;
    //     });
    // }
    fetchSuggestions(terms) {
  if (this.searchSuggestionsAbortController) {
    this.searchSuggestionsAbortController.abort('Existing request not needed');
  }

  this.searchSuggestionsAbortController = new AbortController();

  // ✅ normalize here
  const normalizedTerms = normalizeQuery(terms);

  fetch(`${theme.routes.predictiveSearch}?q=${encodeURIComponent(normalizedTerms)}&section_id=search-suggestions`, {
    signal: this.searchSuggestionsAbortController.signal
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.text();
    })
    .then((text) => {
      const results = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('.search-suggestions-wrapper');

       if (!results) return; 

      this.innerHTML = '';
      this.insertAdjacentElement('beforeend', results.firstElementChild);
    })
    .catch((error) => {
      console.warn(error);
      if (error.code === 20) return;
      throw error;
    });
}

  };

  window.customElements.define('search-suggestions', SearchSuggestions);
}
